
import { Component, Vue } from "vue-property-decorator";
import SquareShadowBox from "@/components/SquareShadowBox.vue";

@Component({
  components: { SquareShadowBox },
})
export default class Firma extends Vue {
  public isValid: boolean = true;
}
